<template>
  <SfFooter :column="7" multiple class="footer">
    <div class="sf-footer-column" style=" grid-row: span 2;grid-column: 1 / 3;">
      <div v-if="companyInfo">
        <div style="margin:var(--spacer-sm) 0;margin-bottom:0;max-height: 50px;">
          <SfImage v-if="companyInfo.image" class="footer__logo" style="height:50px;" :src="companyInfo.image" :alt="'Logo'"
            :height="50" />
        </div>
        <div v-if="companyInfo.description" class="sf-list__item" style="margin:var(--spacer-sm) 0;">
          <div class="description">{{ companyInfo.description }}</div>
        </div>
        <div>
          <SfList class="companyList">
            <SfListItem v-if="companyInfo.address">
              <div class="companyItem">
                <div>
                  <img :src="addBasePath('/icons/company/address.png')" alt="address" class="iconsm" />
                </div>
                <div class="info-text">{{ companyInfo.address }}</div>
              </div>
            </SfListItem>
            <SfListItem v-if="companyInfo.phone || companyInfo.phoneName">
              <div class="companyItem">
                <div>
                  <img :src="addBasePath('/icons/company/phone.png')" alt="address" class="iconsm" />
                </div>
                <div class="info-text">{{ companyInfo.phone }} {{ companyInfo.phoneName }}</div>
              </div>
            </SfListItem>
            <SfListItem v-if="companyInfo.email">
              <div class="companyItem">
                <div>
                  <img :src="addBasePath('/icons/company/emaill.png')" alt="address" class="iconsm" />
                </div>
                <div class="info-text">{{ companyInfo.email }}</div>
              </div>
            </SfListItem>
            <SfListItem>
              <SfMenuItem>
                <template #label>
                  <div class="companyItem">
                    <div>
                      <img @click="openKeFu" :src="addBasePath('/icons/company/contact.png') " alt="address"
                        class="iconsm" />
                    </div>
                    <div class="info-text" @click="openKeFu">{{ $t('onlineContact') }}</div>
                  </div>
                </template>
              </SfMenuItem>
            </SfListItem>
          </SfList>
        </div>
      </div>
    </div>
    <SfFooterColumn :title="$t('About us')" class="columnsm" v-if="aboutUs && aboutUs.length">
      <SfList>
        <SfListItem v-for="(item, index) in aboutUs" :key="item.article_id">
          <SfMenuItem v-if="index <= 2" :label="item.title">
            <template #label>
              <nuxt-link :class="item.article_id ? 'a-link' : ''" :to="localePath(th.getArtcleLink(item.article_id))">
                {{ item.title }}
              </nuxt-link>
            </template>
          </SfMenuItem>
        </SfListItem>
      </SfList>
    </SfFooterColumn>
    <SfFooterColumn :title="$t('Departments')" class="columnsm" v-if="departments && departments.length">
      <SfList>
        <SfListItem v-for="item in departments" :key="item.article_id">
          <SfMenuItem :label="item.title">
            <template #label>
              <nuxt-link :class="item.article_id ? 'a-link' : ''" :to="localePath(th.getArtcleLink(item.article_id))">
                {{ item.title }}
              </nuxt-link>
            </template>
          </SfMenuItem>
        </SfListItem>
      </SfList>
    </SfFooterColumn>
    <SfFooterColumn :title="$t('Help')" class="columnsm" v-if="help && help.length">
      <SfList>
        <SfListItem>
          <SfMenuItem :label="$t('Contact_us')">
            <template #label>
              <nuxt-link :class="'a-link'" :to="localePath('/contactus')">
                {{ $t('Contact_us') }}
              </nuxt-link>
            </template>
          </SfMenuItem>
        </SfListItem>
        <SfListItem v-for="item in help" :key="item.article_id">
          <SfMenuItem :label="item.title">
            <template #label>
              <nuxt-link :class="item.article_id ? 'a-link' : ''" :to="item.title == 'Contact us'
                ? localePath('/contactus')
                : localePath(th.getArtcleLink(item.article_id))
                ">
                {{ item.title }}
              </nuxt-link>
            </template>
          </SfMenuItem>
        </SfListItem>
      </SfList>
    </SfFooterColumn>
    <SfFooterColumn :title="$t('SERVICE')" class="columnsm" v-if="paymentsDelivery && paymentsDelivery.length">
      <SfList>
        <SfListItem v-for="item in paymentsDelivery" :key="item.article_id">
          <SfMenuItem :label="item.title">
            <template #label>
              <nuxt-link :class="item.article_id ? 'a-link' : ''" :to="localePath(th.getArtcleLink(item.article_id))">
                {{ item.title }}
              </nuxt-link>
            </template>
          </SfMenuItem>
        </SfListItem>
      </SfList>
    </SfFooterColumn>
    <SfFooterColumn :title="$t('Social')" v-if="social && social.length > 0 && false">
      <div class="footer__socials">
        <span v-for="(item, key) in social" :key="key">
          <SfImage v-if="item.iso" class="footer__social-image" :src="addBasePath('/icons/' + item.iso + '.svg')"
            :alt="item.iso" :width="32" :height="32" @click="openLink(item.link)" />
        </span>
      </div>
    </SfFooterColumn>
    <SfFooterColumn :title="$t('Links')" class="columnsm" v-if="bottomLink && bottomLink.length">
      <SfList>
        <SfListItem v-for="(item, index) in bottomLink" :key="'bootomLink' + index">
          <SfMenuItem :label="item.title">
            <template #label>
              <a v-if="item.link.indexOf('http') === -1" :href="localePath(item.link)" target="_blank"
                style="color:#fff" class="a-link">
                {{ item.title }}
              </a>
              <a v-else :href="item.link" target="_blank" style="color:#fff" class="a-link">
                {{ item.title }}
              </a>
            </template>
          </SfMenuItem>
        </SfListItem>
      </SfList>
    </SfFooterColumn>
    <div class="sf-footer-column" v-if="mediaList && mediaList.length" style="grid-column: 3 / 8;">
      <div class="mediaFooter">
        <div v-for="(item, index) in mediaList" :key="'mediaList' + index" @click="openLink(item.link)">
          <SfImage :src="item.image" :width="46" :height="46"
            style="border-radius: 8px;overflow: hidden;width:46;margin:0;margin-left:1.5rem;cursor: pointer;"
            :alt="'media' + index" />
        </div>
      </div>
    </div>
    <!-- <SfFooterColumn v-if="mediaList && mediaList.length" class="hiddenColumn" style="grid-column: 5 / 7;">
      <div style="display: flex;justify-content: flex-start;">
        <a v-for="(item, index) in mediaList" :key="'mediaList' + index">
          <SfImage :src="item.image" :width="32" :height="32" @click="openLink(item.link)"
            style="border-radius: 8px;overflow: hidden;width:32px;margin:0;margin-right:1rem;cursor: pointer;"
            :alt="'media' + index" />
        </a>
      </div>
    </SfFooterColumn> -->
  </SfFooter>
</template>

<script>
import { SfFooter, SfList, SfImage, SfMenuItem } from "@storefront-ui/vue";
import { addBasePath, onSSR } from "@vue-storefront/core";
import { useArtcle } from "@bee-hole/coms";
import { computed } from "@nuxtjs/composition-api";
import { useUiHelpers, useUiState } from "~/composables";
export default {
  components: {
    SfFooter,
    SfList,
    SfImage,
    SfMenuItem
  },
  setup(props, context) {
    const { articleGet, artcleList } = useArtcle();
    const th = useUiHelpers();
    const { isMobile } = useUiState();
    const aboutUs1 = computed(() => artcleList.value?.list[1]?.map(item => {
      return { title: item?.title, article_id: item?.article_id };
    }));
    const departments1 = computed(() => artcleList.value?.list[2]?.map(item => {
      return { title: item?.title, article_id: item?.article_id };
    }));
    const help1 = computed(() => artcleList.value?.list[3]?.map(item => {
      return { title: item.title, article_id: item.article_id };
    }));
    const paymentsDelivery1 = computed(() => artcleList.value?.list[4]?.map(item => {
      return { title: item.title, article_id: item.article_id };
    }));
    onSSR(async () => {
      await articleGet();
    });
    const social = computed(() => {
      if (!context?.root?.$options?.$storeConfig?.mall_home_type || context?.root?.$options?.$storeConfig?.mall_home_type === 'default') {
        return context?.root?.$options?.$mallConfig?.mall_zx_home?.Social;
      } else {
        return context?.root?.$options?.$mallConfig?.mall_home_artice?.Sociall;
      }
    });
    const mediaList = computed(() => {
      return context?.root?.$options?.$mallConfig?.mall_web_config?.mediaLink;
    });
    const companyInfo = computed(() => {
      return context?.root?.$options?.$mallConfig?.mall_web_config?.companyInfo;
    });
    const bottomLink = computed(() => {
      const links = context?.root?.$options?.$mallConfig?.mall_web_config?.bottomLink || [];
      const mall_links = context?.root?.$options?.$storeConfig?.mall_links;
      if (mall_links) {
        try {
          return links.concat(JSON.parse(mall_links));
        } catch (err) {
          return links;
        }
      } else {
        return links;
      }
    });
    const openLink = (link) => {
      if (link) {
        window.open(link, "_blank");
      }
    };
    const openKeFu = () => {
      if (companyInfo.value.contact)
        window.open(companyInfo.value.contact, "_blank");
    };
    return {
      th,
      addBasePath,
      aboutUs: aboutUs1,
      departments: departments1,
      isMobile,
      help: help1,
      paymentsDelivery: paymentsDelivery1,
      social,
      openLink,
      bottomLink,
      openKeFu,
      mediaList,
      companyInfo
    };
  },
  data() {
    return {
      desktopMin: 1024
    };
  }
};
</script>

<style lang="scss">
.footer {
  position: relative;
  z-index: 999999999;
  img {
    pointer-events: none;
    user-select: none;
  }
  --c-text: #fff !important;
  margin-bottom: 3.75rem;
  .sf-heading__title.h5{
    font-weight: var(--font-weight--semibold) !important;
    text-align: left;
    font-size: var(--font-size--sm) !important;
  }
  .a-link {
    color: #fff !important;
    font-weight: 300;
    text-align: left;
  }
  .columnsm {
    .a-link{
      font-size: var(--font-size--xs);
    }
    @include for-mobile{
      .sf-list {
        padding: 0 var(--spacer-sm);
      }
    }
  }
  @include for-desktop {
    margin-bottom: 0;
  }

  &__socials {
    display: flex;
    justify-content: space-between;
    margin: 0 auto var(--spacer-lg);
    padding: var(--spacer-base) var(--spacer-xl);

    @include for-desktop {
      justify-content: flex-start;
      padding: var(--spacer-xs) 0;
      align-items: start;
    }

    .sf-image--wrapper {
      margin: 0;
    }
  }

  &__social-image {
    margin: 0 var(--spacer-2xs) 0 0;
  }
  .description {
    font-size: 0.7rem;
    line-height: 2;
    color: #919295;
  }
  @include for-mobile{
    padding-bottom: var(--spacer-xl);
  }
  .mediaFooter{
    display: flex;
    @include for-desktop{
      padding-right: 0;
      justify-content: flex-end;
    }
    @include for-mobile{
      padding-right: 0rem;
      justify-content: flex-start;
      .sf-image--wrapper{
        margin-right: 1.5rem !important;
        margin-left: 0 !important;
      }
    }
  }
}

.sf-footer {
  --c-secondary: #313131;
  @include for-desktop {
    border-top: 0;
    margin-top: var(--spacer-2xl);
    padding: var(--spacer-sm) 0 var(--spacer-base) 0 !important;
  }

  &__container {
    margin: var(--spacer-sm);
    @include for-desktop {
      max-width: 1240px;
      margin: 0 auto;
      gap: var(--spacer-lg);
    }
  }
  &-column{
    @include for-desktop {
      margin-bottom: 0;
      .sf-footer-column__title{
        padding-bottom: var(--spacer-xs);
      }
    }
    @include for-mobile{
      .sf-footer-column__title{
        padding: var(--spacer-xs);
      }
    }
  }
  .hiddenColumn{
    .sf-footer-column__title{
      display: none;
    }
  }
  .companyItem{
    display: flex;
    align-items: flex-start;
    .iconsm{
      width: var(--font-size--lg);
      height: var(--font-size--lg);
      display: block;
    }
    img{
      margin-right: 0.5rem;
    }
    .info-text{
      text-align:left;
      font-weight:300;
      font-size: var(--font-size--sm) !important;
    }
  }
  .companyList{
    .sf-list__item{
     @include for-mobile{
      // padding: 0 24px;
      margin-left:0;
      margin-right:0;
     }
    }
  }
  .description{
    @include for-mobile{
      // padding: 0 24px;
    }
  }
  .footer__logo{
    @include for-mobile{
      // margin-left: 24px;
    }
  }
}
</style>
